import { useEffect, useState } from "react";
import SearchComponent from "../../components/SearchComponent";
import { ApiService } from "../../utils/ApiService";
import { showToast } from "../../common/Toast";
import { Avatar, formatDateTime } from "../../common/Functions";
import Pagination from "../../common/Pagination";

const Subscription = () => {
    const [search, setSearch] = useState("");
    const [hostData, setHostData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedHost, setSelectedHost] = useState({});
    const [startingIndex, setStartingIndex] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalUser: 5,
    });

   const TransactionsData = [
    ]

    useEffect(() => {
        if (search) {
            console.log(search)
            const filtered = TransactionsData.filter((item) =>
                item.transactionsId?.toLowerCase().includes(search?.toLowerCase()) ||
                item.eventId?.toLowerCase().includes(search?.toLowerCase()))
            setFilteredData(filtered);
        } else {
            setFilteredData(TransactionsData);
        }
    }, [search]);

    const handlePagination = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPage(newPage);
        }
    }

    useEffect(() => {
        setFilteredData(TransactionsData);
    }, [])
    return (
        <div className="flex-grow bg-gray-100  px-6 py-2 w-full overflow-auto h-[90vh]">
            <SearchComponent search={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by transaction id, event id..." />
            {<>
                <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
                    <table className="w-full text-center">
                        <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
                            <tr>
                                <th className="p-4 text-left">Event Id</th>
                                <th className="p-4 text-left">Date & Time</th> {/* <-- left aligned header */}
                                <th className="p-4 text-left">Host Name</th>
                                <th className="p-4 text-left">Amount</th>
                                <th className="p-4 text-left">Transactions Id</th>
                                <th className="p-4 text-left">Status</th>
                            </tr>
                        </thead>

                        {/* Table body */}
                        <tbody>
                            {filteredData.map((host, index) => (
                                <tr key={host._id} className="border-t hover:bg-gray-50 cursor-pointer" >
                                    <td className="p-4 text-left">#{host.eventId}</td>
                                    <td className="p-4 text-left text-gray-600">{formatDateTime(host.dateTime) || "--"}</td>
                                    {/* <-- Important: LEFT aligned cell with flex row for avatar + name */}
                                    <td className="p-4text-left" onClick={() => setSelectedHost(host)}>
                                        <div className="flex items-center gap-4">
                                            {/* Avatar: circle, fixed size, object-cover if image */}
                                            <Avatar name={host.hostName} image={host.image} size={32} />

                                            {/* Name text */}
                                            <div className="text-sm font-medium text-gray-800 whitespace-nowrap">
                                                {host.hostName}
                                            </div>
                                        </div>
                                    </td>

                                    <td className="p-4 text-left">{String(host.amount || 0).padStart(2, "0")}</td>
                                    <td className="p-4 text-left">
                                        {host.transactionsId}
                                    </td>
                                    <td className="p-4 text-left">
                                        {host.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {filteredData.length === 0 && (
                        <p className="text-center py-10 text-gray-500">
                            No results found
                        </p>
                    )}
                </div>
                <Pagination
                    page={page}
                    totalPages={pagination.totalPages}
                    totalItems={pagination.totalUser}
                    limit={limit}
                    onPageChange={(newPage) => handlePagination(newPage)}
                />
            </>}
        </div>
    )
}
export default Subscription;